import getConnectedAccountUserConfiguration from '../selectors/getConnectedAccountUserConfiguration';
import getUserConfiguration from '../actions/getUserConfiguration';
import isDefaultMailbox from '../selectors/isDefaultMailbox';

export default function getAttachmentPolicy(userIdentity?: string | undefined) {
    const userConfiguration =
        !userIdentity || isDefaultMailbox(userIdentity)
            ? getUserConfiguration()
            : getConnectedAccountUserConfiguration(userIdentity);

    return userConfiguration?.AttachmentPolicy;
}
